import { defineComponent as _defineComponent } from 'vue'
import { computed, ref } from 'vue';
import { notify } from '@/modules/common/helpers/notification';
import { NotificationTypes } from '@/modules/common/services/http/notification';

import {
  Modal,
  Heading,
  ContentDisplay,
  BaseText,
  ListDisplay,
  ButtonContainer,
  ButtonPrimary,
  ButtonSecondary
} from '@warrenbrasil/nebraska-web';
import { Portal } from '@/modules/common/components/Portal';

import { portfolioTermSignature } from '@/modules/wealth/services/portfolio-terms';
import { IPortfolioTermsData } from './types';

interface Props {
  isOpen: boolean;
  portfolioId: string;
  portfolioTerms: IPortfolioTermsData;
}

interface EmitEvents {
  (event: 'close'): void;
  (event: 'accepted'): void;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'PortfolioTermsModal',
  props: {
    isOpen: { type: Boolean },
    portfolioId: null,
    portfolioTerms: null
  },
  emits: ["close", "accepted"],
  setup(__props: any, { emit }: { emit: ({
  (event: 'close'): void;
  (event: 'accepted'): void;
}), expose: any, slots: any, attrs: any }) {

const { portfolioId, portfolioTerms } = __props as {
  isOpen: boolean;
  portfolioId: string;
  portfolioTerms: IPortfolioTermsData;
}





const isLoading = ref(false);

const portfolioIdParam = computed(() => {
  return portfolioId;
});

function goToTerms(url: string) {
  window.open(url, '_blank');
}

async function termsSignature(data: IPortfolioTermsData) {
  try {
    isLoading.value = true;

    const params = {
      termId: data.termId!,
      customerRiskLabel: data.customerRiskLabel!,
      recommendedPortfolioRisk: data.recommendedPortfolioRisk!,
      portfolioRiskScore: data.portfolioRiskScore!,
      portfolioRiskLabel: data.portfolioRiskLabel!
    };

    await portfolioTermSignature(portfolioIdParam.value, params);

    emit('accepted');
  } catch {
    notify({
      group: 'wrn-notifications',
      text: 'Não foi possível aceitar os termos. Aguarde alguns instantes e tente novamente.',
      type: NotificationTypes.error
    });

    emit('close');
  } finally {
    isLoading.value = false;
  }
}

return { __sfc: true,emit, isLoading, portfolioIdParam, goToTerms, termsSignature, Modal, Heading, ContentDisplay, BaseText, ListDisplay, ButtonContainer, ButtonPrimary, ButtonSecondary, Portal }
}

})